import React, { useState, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { Select, FormField, Tooltip, Button} from 'components';
import { ClbBanks } from './components';
import { ibanAfmValidation, updateFormField, updateIbanDetails } from 'store/forms/actions';
import { omit, isNil, } from 'lodash';
import { Row, Col, Form } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { maskIBAN , isAuditor, isSupplierBankValid } from 'utils';
import { totalCount } from './utils';
import { useForm } from 'antd/lib/form/Form';
import { ReactComponent as Warning } from 'assets/icons/warning-orange-v2.svg';
import { ReactComponent as Info } from 'assets/icons/info-icon.svg';
import { formFields } from './formFields';
import { isBeneficiary ,isObjectionCommittee} from '../../../../../utils';

const BankData = ({ disabled, extended }) => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const bnkClbBanks = useSelector(state => state.forms.bank.bnkClbBanks) || [
    { bnkClbBank: null, synBankShare: null },
  ];
  const bank = useSelector(state => state.forms.bank);
  const jvBanks = useSelector(state => state.forms.items.jvBanks);
  const beneficiaryIban = useSelector(state => state.forms.bank.beneficiaryIban)
  const activeTaskName = useSelector(state => state?.forms?.activeTaskName);
  const applicationReturned = useSelector(state => state.forms?.carrier?.applicationReturned);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const requiresIbanUpdate = useSelector(state => state.forms.bank.requiresIbanUpdate);
  const enableIbanUpdate  =
    process.env.REACT_APP_REQUIRES_IBAN_UPDATE === 'true';
  const viewMode = isViewMode || 
                  !isBeneficiary(user.groups) || 
                  applicationReturned ||
                  activeTaskName === "task.name.temporary_rejected" ||
                  activeTaskName === "task.name.application_returned_to_supplier" ||
                  (activeTaskName ==="task.name.accepted" && !(requiresIbanUpdate || enableIbanUpdate ));
  const isIbanUpdateMode =
    activeTaskName === "task.name.accepted" && (requiresIbanUpdate || enableIbanUpdate );
  const currentIban = bank?.beneficiaryIban;
  const initialIban = bank?.initialBeneficiaryIban;
  const isIbanChanged = currentIban !== initialIban;
  const isIbanValid = isSupplierBankValid(bank);
  const swiftBIC = useSelector(state => state.forms.bank.swiftBIC);
  const processInstanceId = useSelector(state => state.forms.task.processInstanceId);
  const [valid, setValid] = useState(true);
  const [form] = useForm();
  const [bankValue, setBankValue] = useState({bnkBank: bank.bnkBank
    ? jvBanks.find(b => b.key === bank.bnkBank || b.id === bank.bnkBank).name
    : null})
  const [ibanAfmValidationResponse, setIbanAfmValidationResponse] = useState(true);
  // const [ibanAfmValidation, setIbanAfmValidation] = useState(false);
  const [ibanValidationErrorMsg, setIbanValidationErrorMsg] = useState();
  const abiVat = useSelector(state => state.forms.carrier.abiVat);

  useEffect(() => {
    if(bank.ibanValidation){
      if(!isNil(bank.ibanValidation.error)){//in case of server error
        setIbanValidationErrorMsg("Παρουσιάστηκε τεχνικό σφάλμα κατά τον έλεγχο διασταύρωσης του IBAN με το ΑΦΜ της αίτησης. Παρακαλώ δοκιμάστε ξανά αργότερα.");
        setIbanAfmValidationResponse(false);
      }//in case of service error
      else if(bank.ibanValidation.confirmAccountOutputRecord === null && bank.ibanValidation?.errorRecord !== null){      
          setIbanValidationErrorMsg(bank.ibanValidation.errorRecord?.errorDescr);
          setIbanAfmValidationResponse(false);
      }else{
        const confirmed = bank?.ibanValidation?.confirmAccountOutputRecord?.confirmed;
        const usageAllowed = bank?.ibanValidation?.confirmAccountOutputRecord?.usageAllowed;

        if(confirmed === "1" && usageAllowed === "1"){
          setIbanAfmValidationResponse(true);
          setIbanValidationErrorMsg("");
        }else if(confirmed === "0" && usageAllowed === "0"){
          setIbanAfmValidationResponse(false)
          setIbanValidationErrorMsg("Ανεπιτυχής διασταύρωση ΑΦΜ με IBAN. Ανενεργός Λογαρισμός.");
        }else if(confirmed === "0"){
          setIbanAfmValidationResponse(false)
          setIbanValidationErrorMsg("Ανεπιτυχής διασταύρωση ΑΦΜ με IBAN.");
        }else if(usageAllowed === "0"){
          setIbanAfmValidationResponse(false)
          setIbanValidationErrorMsg("Ανενεργός Λογαρισμός.");
        }
      } 
    }
  },[bank.ibanValidation])

  useEffect(() => {
    if(!isBeneficiary(user?.groups)){
      if(bank?.beneficiaryIban?.length === 27)
      {
        form.setFieldsValue({'beneficiaryIban': maskIBAN(bank.beneficiaryIban)})
      }
    }
  },[bank.beneficiaryIban])
  
  const handleChange = ({ key, type, event }) => {
    let newValue;
    if(type === 'text'){
      newValue = event.target.value;
      if(key === 'beneficiaryIban' && newValue.length === 27){
       dispatch(ibanAfmValidation(newValue, abiVat));
      }
    } else {
      newValue = event;
    }

    dispatch(
      updateFormField({ 
        group: 'bank', 
        key, 
        value: newValue 
      })
    );

    if ( key === 'bnkBank') {
        dispatch(
          updateFormField({ 
            group: 'bank', 
            key: 'swiftBIC', 
            value: {bnkBank: event
              ? jvBanks.find(b => b.key === event || b.id === event).code
              : null}.bnkBank
          }));
    }
  };

  return (
    <div className="pt-1 bank-form-container mt-2">
        { !ibanAfmValidationResponse &&
        (
          <div className='warning-message-bank-form-wrapper'>
            <Warning className='warning-bank-form-icon'/>
            <div className='warning-message-bank-form-message'>
              { !isNil(ibanValidationErrorMsg) && 
              <span>{ibanValidationErrorMsg}</span>}
            </div>
          </div>
        )}
      <Row align="middle" gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }} className='mt-1'>
      <Col span={24} className="pt-0 pb-1">
          <span className='ml-0'>
              <span className="mt-0 mr-0  text-bold font-size-16">
                Παρακαλώ επιλέξτε το πιστωτικό ίδρυμα με το οποίο επιθυμείτε να συνεργαστείτε στο πλαίσιο του προγράμματος.
              <span className=" text-bold font-size-16 color-red"> *</span>
            </span>
          </span>
          </Col>
         <Col span={8} className="pt-0 pb-1">
          <Form form={form} initialValues={{...bankValue, beneficiaryIban}}>
            <Form.Item className="bank-select-item" name={'bnkBank'} rules={[{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }]}>
              <Select
                bold
                
                onChange={value => {
                  handleChange({ key: 'bnkBank', event: value });
                }}
                value={bankValue}
                disabled={viewMode}
                placeholder={'Επιλέξτε'}
                allowClear='true'
                options={
                  !isEmpty(jvBanks)
                    ? jvBanks
                        .filter(b => b.isMain === 'true')
                        .map(b => ({
                          label: b.name,
                          value: b.id,
                        }))
                    : []
                }
              />
              </Form.Item>
              </Form>
                </Col>
                  {!viewMode &&
                    isBeneficiary(user?.groups) &&
                    isIbanUpdateMode && (
                      <Col span={8} className="pt-0 pb-1">
                      <Button
                        type="primary"
                        id="save-iban-btn"
                        className="save-iban-btn"
                        label={'Αποθήκευση IBAN'}
                        disabled={!(isIbanChanged && isIbanValid)}
                        onClick={() => {
                          dispatch(updateIbanDetails(processInstanceId, {
                            swiftBIC: swiftBIC,
                            beneficiaryIban: beneficiaryIban,
                            bnkBank: bank.bnkBank
                          }));
                        }}
                      />
                 </Col>
                  )}
            </Row>
            <Row gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}>
            <Col span={8} className="pt-1 pb-1">
              <div className='mb-1 mt-1'>
              <span className='mt-0 mr-0  text-bold font-size-16'>IBAN <span className=" text-bold font-size-16 color-red"> * </span></span>
              <Tooltip
                placement='right'
                className='iban-info'
                title={<span className='iban-info-title'>Δήλωση τραπεζικού λογαριασμού (IBAN) που ήδη τηρεί ο ωφελούμενος στο<br/>
               πιστωτικό ίδρυμα της επιλογής του για την καταβολή της ενίσχυσης στο πλαίσιο<br/>
               του προγράμματος και σύμφωνα με το κανονιστικό πλαίσιο που διέπει τη<br/>
                διενέργεια των πληρωμών του.</span>}>
                <Info className="infoIconSmallIban"/>
              </Tooltip>
              </div>
            
          {formFields.map((field, index) => {
            return (
              <Form form={form} initialValues={{...bankValue, beneficiaryIban}}>
              <Form.Item
                    name={[field.name]}
                    rules={field.rules}
                    validateFirst
                    value={beneficiaryIban}
                  >
                    <FormField
                      key={index}
                      disabled={viewMode}
                      {...omit(field, ['span', 'rules'])}
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  </Form.Item>
                  </Form>
            )
          })}
         
        </Col>
      </Row>
    </div>
  );
};

export default BankData;
